module.exports = __webpack_public_path__ + "assets/events_terrorism_blue.44eaf161.svg";